"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = void 0;

var _util = require("../../../util");

const css = ({
  cssProps,
  theme
}) => {
  const {
    variant = 'primary'
  } = cssProps;
  const variantTheme = theme.links[variant];
  return { ...(0, _util.textStyle)(theme, variantTheme.textStyle),
    color: (0, _util.color)(theme, variantTheme.color),
    cursor: 'pointer',
    textDecoration: variantTheme.textDecoration,
    ':active': {
      color: (0, _util.color)(theme, variantTheme.activeColor)
    },
    ':hover': {
      color: (0, _util.color)(theme, variantTheme.hoverColor)
    },
    ':disabled': {
      color: (0, _util.color)(theme, variantTheme.disabledColor),
      cursor: 'not-allowed',
      ':hover': {
        color: (0, _util.color)(theme, variantTheme.disabledColor)
      }
    }
  };
};

exports.css = css;
//# sourceMappingURL=Link.style.js.map